export default "__VITE_ASSET__XAek9sJq__"